/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/heading-has-content */
import React, { useEffect, useState } from "react";
import { unidadDeLinea, contenidoEmpaqueDeLinea } from "../../../../utils/unidades";
import { useParams } from "react-router-dom";
import { request } from "../../../../utils/request";
import { formatCurrency, getSucursal, money } from "../../../../utils/helpers";
import dayjs from "dayjs";

const tipos_impuesto = {
	itbis: "Itbis",
	otro: "Otro",
	isc: "ISC",
	propina_legal: "Propina",
	no_facturable: "No facturable",
	exento: "Exento",
};

const tiposComprobante = [
	"B01",
	"B02",
	"B14",
	"B15",
	"B16",
	"B11",
	"B03",
	"B11",
];

const tipoITBIS = (impuesto, omitir) => {
	if (!impuesto || omitir) return "";
	if (impuesto.tipo === "itbis" && impuesto.porcentaje === 0.16) {
		return "I1";
	} else if (impuesto.tipo === "itbis" && impuesto.porcentaje === 0.18) {
		return "I2";
	} else if (impuesto.tipo === "itbis" && impuesto.porcentaje === 0) {
		return "IE";
	}

	return "";
};

const getDiasPlazo = (fecha, fecha_vencimiento) => {
	fecha = new Date(fecha);
	fecha_vencimiento = new Date(fecha_vencimiento);

	let difference = fecha.getTime() - fecha_vencimiento.getTime();
	let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
	return Math.abs(TotalDays);
};

const limitVendedorFullName = (name) => {
	name = name.split(" ");

	if (name.length <= 3) return name.join(" ");

	return name.slice(0, 3).join(" ");
};

const PrintSingleCotizacion = () => {
	const { id } = useParams();

	const [factura, setFactura] = useState({
		productos: [],
	});
	const [sucursal, setSucursal] = useState({});
	const [infoBlock2Margin, setInfoBlock2Margin] = useState(10);

	const [sumatoriaFinal, setSumatoriaFinal] = useState({
		impuestos: {},
	});
	const [impuestosTotal, setImpuestosTotal] = useState(0);
	const [isMobileDevice, setIsMobileDevice] = useState(false);
	const [omitir, setOmitir] = useState(true);
	const [listo, setListo] = useState(false);

	const getFactura = () => {
		request("cotizaciones/" + id).then((res) => {
			setFactura(res.data);
		});
	};

	const calcularImpuestos = (productos) => {
		let impuestos = {};

		if (productos) {
			productos.forEach((producto) => {
				if (
					!tipos_impuesto[producto.impuesto?.tipo] ||
					producto.impuesto?.porcentaje === 0
				)
					return;

                const key = `${tipos_impuesto[producto.impuesto.tipo]} ${
                    producto.impuesto.porcentaje * 100
                }%`;
                const descuento = producto.descuento ? producto.cantidad * producto.importe * (producto.descuento / 100) : 0;

				if (!Object.hasOwnProperty.call(impuestos, key)) {
					impuestos[key] = 0;
				}

				impuestos[key] +=
                    producto.cantidad * (
                        (producto.importe - descuento) * producto.impuesto.porcentaje
                    );
			});
		}

		return impuestos;
	};

	useEffect(() => {
		getFactura();
		const sucursalInfo = JSON.parse(localStorage.getItem("user"));
		setSucursal(
			sucursalInfo.sucursales.find(
				(sucursal) => sucursal.id === getSucursal()
			)
		);

		// check if device is not a PC
		let isMobile = navigator.userAgent.toLowerCase().match(/mobile/i),
			isTablet = navigator.userAgent.toLowerCase().match(/tablet/i),
			isAndroid = navigator.userAgent.toLowerCase().match(/android/i),
			isiPhone = navigator.userAgent.toLowerCase().match(/iphone/i),
			isiPad = navigator.userAgent.toLowerCase().match(/ipad/i);

		if (isMobile || isTablet || isAndroid || isiPhone || isiPad) {
			setIsMobileDevice(true);
		}
	}, []);
	useEffect(() => {
		setSumatoriaFinal((state) => ({
			...state,
			impuestos: calcularImpuestos(factura.productos),
		}));

		if (isMobileDevice) return;
		// This is for calculate the margin of the second column of client info. that way the last row of each column will be alined
		const infoBlock1 = document.getElementById("info-block-1");
		const infoBlock2 = document.getElementById("info-block-2");
		const count =
			infoBlock2.childElementCount - infoBlock1.childElementCount;
		if (count >= 5 && !factura.logo && !sucursal.logo) {
			setInfoBlock2Margin((count * 25 - 40) * -1);
		} else {
			setInfoBlock2Margin((count * 25 + 10) * -1);
		}
	}, [factura]);
	useEffect(() => {
		let suma = 0;
		for (const key in sumatoriaFinal) {
			if (sumatoriaFinal.hasOwnProperty(key)) {
				const impuestos = sumatoriaFinal[key];

				for (const key2 in impuestos) {
					if (Object.hasOwnProperty.call(impuestos, key2)) {
						suma += impuestos[key2];
					}
				}
			}
		}

		setImpuestosTotal(suma);

		if (factura.id) {
			setListo(true);
		}
	}, [sumatoriaFinal]);

	// Espera a que impuestosTotal ya esté calculado y reflejado en el DOM
	// antes de abrir el diálogo de impresión.
	useEffect(() => {
		if (listo) {
			window.print();
		}
	}, [listo]);
	useEffect(() => {
		if(factura.productos.length > 1){
			const I = factura.productos[0].impuesto.id;

			for (let index = 1; index < factura.productos.length; index++) {
				const impuesto = factura.productos[index].impuesto;

				if (I !== impuesto.id) {
					setOmitir(false);
					return;
				}
			}
		}

		setOmitir(true);
	}, [factura.productos]);

	return (
		<CotizacionTemplate
			factura={factura}
			sucursal={sucursal}
			infoBlock2Margin={infoBlock2Margin}
			sumatoriaFinal={sumatoriaFinal}
			impuestosTotal={impuestosTotal}
			isMobileDevice={isMobileDevice}
			omitir={omitir}
		/>
	);
};

export const CotizacionTemplate = ({
	factura,
	sucursal,
	infoBlock2Margin,
	sumatoriaFinal,
	impuestosTotal,
	isMobileDevice,
	omitir,
}) => {
	return (
		<>
			<MobileLayout
				factura={factura}
				sucursal={sucursal}
				sumatoriaFinal={sumatoriaFinal}
				omitir={omitir}
			/>
			<DesktopLayout
				factura={factura}
				sucursal={sucursal}
				sumatoriaFinal={sumatoriaFinal}
				impuestosTotal={impuestosTotal}
				infoBlock2Margin={infoBlock2Margin}
				omitir={omitir}
			/>
		</>
	);
};

const MobileLayout = ({
	factura,
	sucursal,
	sumatoriaFinal,
	isFactura = () => false,
	status,
	omitir,
}) => {
	return (
		<>
			<style>
				{`
                    @import url('https://fonts.googleapis.com/css2?family=Saira+Extra+Condensed:wght@400;700&display=swap');

                    .invoice-mobile {
                        display: none
                    }

                    body {
                        font-family: "Saira Extra Condensed", sans-serif !important;
                        width: 100% !important;
                        font-size: 12pt !important;
                    }

                    @media print {
                        body {
                            min-width: auto !important;
                        }
                    }

					@media(max-width: 450px){
                        @page {
                            size: 80mm 300mm !important;
                            margin-top: 0 !important;
                            margin-bottom: 0 !important;
                            margin-left: 20px !important;
                            margin-right: 20px !important;
                        }
                        .invoice {
                            width: 100% !important;
                            padding: 0 20px 0 5px;
                        }
                        .invoice small {
                            font-size: 10pt;
                            line-height: 1;
                        }
                        .invoice-table {
                            display: none;
                        }
                        .sm-invoice-table {
                            display: block;
                        }
                        .invoice h3 {
                            margin-bottom: 0.1rem;
                        }
                        .invoice h3.signature-title {
                            font-weight: 600 !important;
                        }
                        .client-info-title {
                            font-weight: 600 !important;
                        }
                        .info-cliente-responsive .info-client__response {
                            line-height: 1.2 !important;
                        }
                        .invoice-name {
                            font-weight: 600 !important;
                        }
                        .info-cliente-responsive {
                            line-height: 1.2 !important;
                            margin-bottom: 5px !important;
                        }
                        .info-cliente-responsive .row{
                            margin-bottom: 6px;
                        }
                        .invoice-mobile {
                            display: block;
                            width: 100% !important;
                        }
                        hr {
                            margin: 5px 0;
                        }
                        .sucursal-name {
                            font-size: 14pt;
                        }
                        .detalles-sucursal {
                            line-height: 1;
                            margin-bottom: 10px;
                        }
                        .top-info {
                            line-height: 1;
                        }
    					.sucursal-name-sm {
    					    display:block;
    					}
                        .producto-item {
                            font-size: 10pt;
                        }
    					.factura-logo{
    					    display:none;
    					}
    					.sucursal-name-lg{
    					    display:none;
    					}
						.info-cliente-responsive .row {
							margin-bottom: 0 !important;
						}
                        .client-info-title {
                            min-width: 90px;
                        }
                        .tabla-titulos small {
                            font-weight: 600;
                        }
                        .totales {
                            line-height: 1.2;
                            margin-bottom: 10px;
                        }
						.summary-text{
							// max-width:39% !important;
							width:auto !important;
							flex:auto;
							padding-left: 5px !important;
							padding-right: 2px !important;
						}
                        .justify-content-between {
							justify-content: flex-end !important;
						}
						.justify-content-between :nth-child(2){
							max-width: 33% !important;
						}
					}
				`}
			</style>
			<div className="invoice invoice-mobile recibo-print">
				<div className="clear-both p-t-30 p-b-10">
					<div>
						<h3 className="sucursal-name text-center">{sucursal.nombre}</h3>
						<div
							className="text-center detalles-sucursal"
						>
							RNC: {sucursal.rnc} TEL.:{sucursal.telefono}<br />
                            {sucursal.direccion}
						</div>
					</div>

					<div className="mb-1 d-flex top-info fechaSpace">
						<div className="d-block">
							<span className="d-block d-sm-none client-info-title pt-2">
								{status}
							</span>
						</div>
						<div className="d-block text-right">
							Fecha: {dayjs(factura.fecha).format("DD/MM/YYYY")}
							<br />
							<span>NO.: </span>
							{factura.numero_comprobante}
							<br />
							{factura.numeracion?.fecha_vencimiento && (
								<>
									<span>FV:</span>{" "}
									{dayjs(
										factura.numeracion?.fecha_vencimiento
									).format("DD/MM/YYYY")}
								</>
							)}
						</div>
					</div>
				</div>

				<div className="info-cliente-responsive d-block">
					{factura.cliente && (
						<div className="d-flex">
							<div className="client-info-title">
								Cliente:
							</div>
							<div className="info-client__response text-uppercase">
								{factura.cliente?.codigo} - {factura.cliente?.nombre}
							</div>
						</div>
					)}
					{factura.cliente?.identificacion && (
						<div className="d-flex">
							<div className="client-info-title">
								RNC/Cédula:
							</div>
							<div className="info-client__response text-uppercase">
								{factura.cliente?.identificacion}
							</div>
						</div>
					)}
					{factura.cliente?.encargado && (
						<div className="d-flex">
							<div className="client-info-title">
								Responsable:
							</div>
							<div className="info-client__response text-uppercase">
								{factura.cliente?.encargado}
							</div>
						</div>
					)}
					{factura.cliente?.telefono && (
						<div className="d-flex">
							<div className="client-info-title">
								Teléfono:
							</div>
							<div className="info-client__response text-uppercase">
								{factura.cliente?.telefono}
							</div>
						</div>
					)}
					{(factura.cliente?.direccion || factura.cliente?.direcciones?.[0]?.direccion) && (
						<div className="d-flex">
							<div className="client-info-title">
								Dirección:
							</div>
							<div className="info-client__response text-uppercase">
								{factura.cliente?.direccion || factura.cliente?.direcciones?.[0]?.direccion}
							</div>
						</div>
					)}
					{factura.vendedor?.nombre && (
						<div className="d-flex">
							<div className="client-info-title">
								Vendedor:
							</div>
							<div className="info-client__response text-uppercase">
								{limitVendedorFullName(
									factura.vendedor?.nombre,
									factura.vendedor?.apellido
								)}
							</div>
						</div>
					)}
				</div>

				<hr style={{borderStyle: 'dashed', borderWidth: '1px', margin: '0'}} />
                <div className="d-block bold tipo-factura text-center uppercase">
                    Cotización
                </div>
				<hr style={{borderStyle: 'dashed', borderWidth: '1px', margin: '0'}} />

				<table style={{ width: '100%', fontSize: 'smaller', borderCollapse: 'collapse' }}>
					<thead>
                        <tr style={{ fontWeight: '600', borderBottom: '1px dashed' }}>
                            <th style={{ textAlign: 'left' }}><small>DESCRIPCIÓN</small></th>
                            <th style={{ textAlign: 'center' }}><small>IMPUESTOS</small></th>
                            <th style={{ textAlign: 'right' }}><small>TOTAL</small></th>
                        </tr>
                    </thead>
					<tbody>
						{factura.productos?.map((producto, index) => {
							// Cotizado por empaque: cuánto trae ese empaque, junto al nombre.
							const contenidoEmpaque = contenidoEmpaqueDeLinea(producto);

							return <tr key={index}>
								<td style={{paddingTop: '5px' }}>
									{`${producto.cantidad} x ${formatCurrency(
										producto.precio_facturado,
										""
									)}`}
									<br />
									REF: {producto.producto?.referencia}
									<br />
                                    {producto.producto.tipo === 'grupo' && producto.producto.componentes && (
                                        <>
                                            {producto.producto.componentes.map(componente => (
                                                <small className="d-block text-muted">
                                                    {componente.cantidad} - {componente.componente.nombre}
                                                </small>
                                            ))}
                                        </>
                                    )}
									{producto.producto?.nombre}
									{contenidoEmpaque && ` (${contenidoEmpaque})`}
								</td>
								<td style={{ textAlign: 'center', paddingTop: '5px' }}>
									<span className="fw-600">
										{tipoITBIS(producto.impuesto, omitir)}
									</span>
									{formatCurrency(
										producto.precio_facturado -
											producto.importe
									)}
								</td>
								<td style={{ textAlign: 'right', paddingTop: '5px' }}>{formatCurrency(producto.total, "$")}</td>
							</tr>
						})}
					</tbody>
				</table>

                <hr className="mt-2" style={{borderStyle: 'dashed', borderWidth: '1px'}} />

				<div className="totales">
					{factura.descuento > 0 && (
						<div className="row justify-content-between">
							<div
								className="col font-weight-bold"
							>
								Descuento
							</div>
							<div
								className="col-2"
							>
								-{formatCurrency(factura.descuento)}
							</div>
						</div>
					)}
					<div className="row justify-content-between">
						<div
							className="col font-weight-bold"
						>
							Subtotal:
						</div>
						<div
							className="col-2"
						>
							{formatCurrency(
								factura.subtotal
							)}
						</div>
					</div>
					<div className="d-block">
						{Object.keys(sumatoriaFinal.impuestos).map(
							(impuesto, index) => {
								return (
									<div
										className="row justify-content-between"
										key={index}
									>
										<div
											className="col font-weight-bold"
										>
											{impuesto}
											{":"}
										</div>
										<div
											className="col-2"
										>
											{formatCurrency(
												sumatoriaFinal.impuestos[
													impuesto
												],
												"$"
											)}
										</div>
									</div>
								);
							}
						)}
					</div>

					<div className="row justify-content-between">
						<div
							className="col font-weight-bold"
						>
							TOTAL A PAGAR:
						</div>
						<div
							className="col-2"
						>
							{formatCurrency(factura.total, "$")}
						</div>
					</div>
				</div>

				<hr className="mt-2" style={{borderStyle: 'dashed', borderWidth: '1px'}} />
				{factura.notas && (
					<>
						<p style={{ fontWeight: "600", fontSize: "1rem" }}>
							Notas:
						</p>
						<p
							className="col-12 pl-0 mb-3"
						>
							{factura.notas}
						</p>
					</>
				)}

				{factura.plantilla?.pie_pagina && (
					<div
						className="col-12 pt-5 text-center d-flex justify-content-center"
					>
						<p className="text-center pie-pagina">
							{factura.plantilla?.pie_pagina}
						</p>
					</div>
				)}
			</div>
		</>
	);
};

const DesktopLayout = ({
	factura,
	sucursal,
	infoBlock2Margin,
	sumatoriaFinal,
	impuestosTotal,
	omitir,
}) => {
	return (<>
		<style>{`
			.invoice-desktop {
				display: block;
			}
			.pie-pagina {
				font-family: "Saira Extra Condensed", sans-serif !important;
			}
			@media (min-width: 500px) {
				body {
					font-family: "Poppins", sans-serif !important;
					font-size: 12pt !important;
				}
			}
			@media (max-width: 450px) {
				.invoice-desktop {
					display: none;
				}
			}
		`}</style>
		<div className="invoice invoice-desktop recibo-print">
			<div className="clear-both p-t-30 p-b-10">
				<div className="float-sm-left sucursal-info">
					{sucursal.logo ? (
						<img
							alt="logo"
							className="mb-2 factura-logo"
							src={sucursal.logo[0].url}
							width="270px"
						/>
					) : factura.logo ? (
						<img
							alt="logo"
							className="mb-2 factura-logo"
							src={factura.logo[0].url}
							width="270px"
						/>
					) : (
						<h3 style={{ lineHeight: "12px", marginBottom: "3px" }}>
							{sucursal.nombre}
						</h3>
					)}
					<div
						className="mb-0 mb-sm-0"
						style={{ lineHeight: "15px", fontSize: "13px" }}
					>
						RNC: {sucursal.rnc} TEL.:{sucursal.telefono}
					</div>
					<div
						className="mb-2 mb-sm-0"
						style={{ lineHeight: "15px", fontSize: "13px" }}
					>
						{sucursal.direccion}
					</div>
				</div>

				<div className="float-sm-right text-sm-right">
					<div
						className="mb-2 invoice-fecha d-block d-sm-none"
						style={{ fontSize: "small", lineHeight: "15px" }}
					>
						Fecha: {dayjs(factura.fecha).format("DD/MM/YYYY")}
						<br />
						{getDiasPlazo(
							factura.fecha,
							factura.fecha_vencimiento
						) > 0 ? (
							<>
								<span>
									Plazo:{" "}
									{getDiasPlazo(
										factura.fecha,
										factura.fecha_vencimiento
									) || 0}{" "}
									días
								</span>
								<br />
							</>
						) : (
							<>
								<span>Plazo: Contado</span>
								<br />
							</>
						)}
					</div>
					<h3
						style={{
							fontSize: "15px",
							lineHeight: "12px",
							marginBottom: "3px",
						}}
						className="d-block d-sm-none"
					>
						Cotización
					</h3>
					<div
						className="d-block d-sm-none"
						style={{ fontSize: "small", lineHeight: "12px" }}
					>
						<span>
							{factura.entidad === "factura" &&
							tiposComprobante.findIndex(
								(tipo) =>
									tipo ===
									factura.numero_comprobante.substring(0, 3)
							) >= 0
								? "NCF: "
								: "COD. "}
							{factura.entidad === "proforma" && "COD. "}
						</span>
						{factura.numero_comprobante}
						<br />
						{factura.numeracion?.fecha_vencimiento && (
							<>
								<span>FV:</span>{" "}
								{dayjs(
									factura.numeracion?.fecha_vencimiento
								).format("DD/MM/YYYY")}
							</>
						)}
					</div>
				</div>
			</div>

			<div className="info-cliente-responsive d-block d-sm-none">
				{factura.cliente && (
					<div className="row">
						<div className="col-4 text-right px-1">
							<span className="client-info-title">Cliente:</span>
						</div>
						<div className="col-7" style={{ lineHeight: "13px" }}>
							{factura.cliente?.codigo} - {factura.cliente?.nombre}
						</div>
					</div>
				)}
				{factura.cliente?.identificacion && (
					<div className="row">
						<div className="col-4 text-right px-1">
							<span className="client-info-title">
								RNC/Cédula:
							</span>
						</div>
						<div className="col-7" style={{ lineHeight: "13px" }}>
							{factura.cliente?.identificacion}
						</div>
					</div>
				)}
				{factura.cliente?.encargado && (
					<div className="row">
						<div className="col-4 text-right px-1 client-info-title">
							Responsable:
						</div>
						<div className="col-7" style={{ lineHeight: "13px" }}>
							{factura.cliente?.encargado}
						</div>
					</div>
				)}
				{factura.cliente?.telefono && (
					<div className="row">
						<div className="col-4 text-right px-1">
							<span className="client-info-title">Teléfono:</span>
						</div>
						<div className="col-7" style={{ lineHeight: "13px" }}>
							{factura.cliente?.telefono}
						</div>
					</div>
				)}
				{(factura.cliente?.direccion || factura.cliente?.direcciones?.[0]?.direccion) && (
					<div className="row">
						<div className="col-4 text-right px-1">
							<span className="client-info-title">
								Dirección:
							</span>
						</div>
						<div className="col-7" style={{ lineHeight: "13px" }}>
							{factura.cliente?.direccion || factura.cliente?.direcciones?.[0]?.direccion}
						</div>
					</div>
				)}
				{factura.vendedor?.nombre && (
					<div className="row">
						<div className="col-4 text-right px-1">
							<span className="client-info-title">Vendedor:</span>
						</div>
						<div className="col-7">
							{limitVendedorFullName(
								`${factura.vendedor?.nombre} ${factura.vendedor?.apellido}`
							)}
						</div>
					</div>
				)}
			</div>

			<div className="clear-both info-row p-t-10 p-b-10 d-none d-sm-flex">
				<div className="info-block" style={{ width: "65%" }}>
					<table>
						<tbody id="info-block-1">
							{factura.cliente?.nombre && (
								<tr>
									<td
										width="120px"
										className="client-info-title text-uppercase text-right"
									>
										Cliente:
									</td>
									<td
										style={{
											lineHeight: "13px",
											paddingLeft: "10px",
										}}
									>
										{factura.cliente?.codigo} - {factura.cliente?.nombre}
									</td>
								</tr>
							)}
							{factura.cliente?.identificacion && (
								<tr>
									<td className="client-info-title text-uppercase text-right">
										RNC/Cédula:
									</td>
									<td style={{ paddingLeft: "10px" }}>
										{factura.cliente?.identificacion}
									</td>
								</tr>
							)}
							{factura.cliente?.encargado && (
								<tr>
									<td className="client-info-title text-uppercase text-right">
										Responsable:
									</td>
									<td style={{ paddingLeft: "10px" }}>
										{factura.cliente?.encargado}
									</td>
								</tr>
							)}
							{factura.cliente?.telefono && (
								<tr>
									<td className="client-info-title text-uppercase text-right">
										Teléfono:
									</td>
									<td style={{ paddingLeft: "10px" }}>
										{factura.cliente?.telefono}
									</td>
								</tr>
							)}
							{(factura.cliente?.direccion || factura.cliente?.direcciones?.[0]?.direccion) && (
								<tr>
									<td className="client-info-title text-uppercase text-right">
										Dirección:
									</td>
									<td
										style={{
											lineHeight: "13px",
											paddingLeft: "10px",
										}}
									>
										{factura.cliente?.direccion || factura.cliente?.direcciones?.[0]?.direccion}
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>

				<div
					className="info-block"
					style={{ marginTop: infoBlock2Margin }}
				>
					<table>
						<tbody id="info-block-2">
							<tr>
								<td colSpan={2} style={{ paddingLeft: "18%" }}>
									<h3
										style={{
											fontSize: "0.9rem",
											marginBottom: "3px",
											paddingBottom: "10px",
										}}
									>
										COTIZACIÓN
									</h3>
								</td>
							</tr>
							{factura.fecha && (
								<tr>
									<td className="client-info-title text-uppercase text-right">
										Fecha:
									</td>
									<td style={{ paddingLeft: "10px" }}>
										{dayjs(factura.fecha).format(
											"DD/MM/YYYY"
										)}
									</td>
								</tr>
							)}
							{factura.numero_comprobante && (
								<tr>
									<td className="client-info-title text-uppercase text-right">
										No.:
									</td>
									<td style={{ paddingLeft: "10px" }}>
										{factura.numero_comprobante}
									</td>
								</tr>
							)}

							{getDiasPlazo(
								factura.fecha,
								factura.fecha_vencimiento
							) > 0 ? (
								<tr>
									<td className="client-info-title text-uppercase text-right">
										Plazo:
									</td>
									<td style={{ paddingLeft: "10px" }}>
										{getDiasPlazo(
											factura.fecha,
											factura.fecha_vencimiento
										) || 0}{" "}
										días
									</td>
								</tr>
							) : (
								<tr>
									<td className="client-info-title text-uppercase text-right">
										Plazo:
									</td>
									<td style={{ paddingLeft: "10px" }}>
										Contado
									</td>
								</tr>
							)}

							{factura.numeracion?.fecha_vencimiento && (
								<tr>
									<td className="client-info-title text-uppercase text-right">
										FV:
									</td>
									<td style={{ paddingLeft: "10px" }}>
										{dayjs(
											factura.numeracion
												?.fecha_vencimiento
										).format("DD/MM/YYYY")}
									</td>
								</tr>
							)}
							{factura.vendedor?.nombre && (
								<tr>
									<td className="client-info-title text-uppercase text-right">
										Vendedor:
									</td>
									<td style={{ paddingLeft: "10px" }}>
										{limitVendedorFullName(
											`${factura.vendedor?.nombre} ${factura.vendedor?.apellido}`
										)}
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
			</div>

			<div className="table-wrapper">
				<h3 className="table-title"></h3>
				<table className="table d-none d-sm-table">
					<thead>
						<tr className="text-uppercase">
							<th width="12%">Código/Ref.</th>
							<th width="25%">Descripción</th>
							<th width="8%">Cantidad</th>
							<th width="8%">Unidad</th>
							<th>Importe</th>
							<th>Impuesto</th>
							<th>Precio</th>
							{factura.descuento > 0 && <th>Descuento</th>}
							<th>Total</th>
						</tr>
					</thead>
					<tbody>
						{factura?.productos?.map((producto) => {
                            const descuento =
                                producto.cantidad *
                                (producto.importe +
                                    producto.importe *
                                        producto.impuesto?.porcentaje) *
                                (producto.descuento / 100);

                            const descuentoReal =
                                (producto.importe *
                                (producto.descuento / 100))
                                * producto.cantidad;

                            // Cotizado por empaque: cuánto trae ese empaque, junto al nombre.
                            const contenidoEmpaque = contenidoEmpaqueDeLinea(producto);

							return (
								<tr key={producto.id}>
									<td>
										<div style={{ lineHeight: 1.2 }}>
											<div>
												{producto.producto.referencia}
											</div>
										</div>
									</td>
									<td>
                                        {producto.producto?.nombre}
                                        {contenidoEmpaque && ` (${contenidoEmpaque})`}
                                        {producto.producto.tipo === 'grupo' && producto.producto.componentes && (
                                            <>
                                                {producto.producto.componentes.map(componente => (
                                                    <small className="d-block text-muted">
                                                        {componente.cantidad} - {componente.componente.nombre}
                                                    </small>
                                                ))}
                                            </>
                                        )}
                                    </td>
									<td>{producto.cantidad}</td>
									<td>{unidadDeLinea(producto)}</td>
									<td>{formatCurrency(producto.importe)}</td>
									<td style={{ whiteSpace: "nowrap" }}>
										<span className="fw-600">
											{tipoITBIS(producto.impuesto, omitir)}
										</span>{" "}
										{formatCurrency(
											producto.precio_facturado - producto.importe
										)}
									</td>
									<td>
										{formatCurrency(producto.precio_facturado)}
									</td>
									{factura.descuento > 0 && (
										<td>
											{formatCurrency(descuentoReal)}
										</td>
									)}
									<td>{formatCurrency(producto.total - descuento)}</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>

			{/* PRODUCTOS RESPONSIVE */}
			<div className="sm-invoice-table">
				<div className="row" style={{ fontWeight: "600" }}>
					<div className="col-5">DESCRIPCIÓN</div>
					<div className="col-3 px-0">IMPUESTOS</div>
					<div className="col-4 ">TOTAL</div>
				</div>

				{factura.productos?.map((producto) => {
					// Cotizado por empaque: cuánto trae ese empaque, junto al nombre.
					const contenidoEmpaque = contenidoEmpaqueDeLinea(producto);

					return (
						<>
							<div
								className="row"
								style={{
									fontSize: "smaller",
									marginBottom: "5px",
								}}
							>
								<div
									className="col-5"
									style={{ lineHeight: "13px" }}
								>
									{`${producto.cantidad} x ${formatCurrency(
										producto.precio_facturado,
										""
									)}`}
									<br />
									{producto.producto?.nombre}
									{contenidoEmpaque && ` (${contenidoEmpaque})`}
									<br />
									REF: {producto.producto?.referencia}
                                    {producto.producto.tipo === 'grupo' && producto.producto.componentes && (
                                        <>
                                            {producto.producto.componentes.map(componente => (
                                                <small className="d-block text-muted">
                                                    {componente.cantidad} - {componente.componente.nombre}
                                                </small>
                                            ))}
                                        </>
                                    )}
								</div>
								<div className="col-3 px-0">
									<span className="fw-600">
										{tipoITBIS(producto.impuesto, omitir)}
									</span>
									{formatCurrency(
										producto.precio_facturado *
											producto.impuesto?.porcentaje,
										"$"
									)}
								</div>
								<div className="col-3 pr-0">
									{formatCurrency(producto.total, "$")}{" "}
								</div>
							</div>
						</>
					);
				})}
			</div>

			<div className="summary pt-3">
				{factura.descuento > 0 && (
					<div className="row justify-content-between justify-content-md-end">
						<div
							className="col-2 text-sm-right"
							style={{
								maxWidth: "8rem",
								textAlign: "end",
								fontWeight: "600",
							}}
						>
							Descuento
						</div>
						<div
							className="col-2 text-right"
							style={{ maxWidth: "9rem" }}
						>
							-{formatCurrency(factura.descuento)}
						</div>
					</div>
				)}
				<div className="row justify-content-between justify-content-md-end">
					<div
						className="col-2 text-sm-right"
						style={{
							maxWidth: "8rem",
							fontWeight: "600",
						}}
					>
						Subtotal
					</div>
					<div
						className="col-2 text-right"
						style={{ maxWidth: "9rem" }}
					>
						{formatCurrency(factura.subtotal)}
					</div>
				</div>
				<div className="d-block">
					{Object.keys(sumatoriaFinal.impuestos).map(
						(impuesto, index) => {
							return (
								<div
									className="row justify-content-between justify-content-md-end"
									key={index}
								>
									<div
										className="col col-md-2 text-sm-right"
										style={{
											maxWidth: "8rem",
											fontWeight: "600",
										}}
									>
										{impuesto}
									</div>
									<div
										className="col-2 text-right"
										style={{
											maxWidth: "9rem",
										}}
									>
										{formatCurrency(
											sumatoriaFinal.impuestos[impuesto],
											"$"
										)}
									</div>
								</div>
							);
						}
					)}
				</div>

				<div className="row justify-content-between justify-content-md-end">
					<div
						className="col col-md-2 text-sm-right"
						style={{
							maxWidth: "8rem",
							fontWeight: "600",
						}}
					>
						TOTAL
					</div>
					<div
						className="col-2 text-right"
						style={{
							maxWidth: "9rem",
							fontWeight: "600",
						}}
					>
						{formatCurrency(factura.total, "$")}
					</div>
				</div>
				{Object.keys(sumatoriaFinal.impuestos).length > 1 && (
					<hr className="mb-0" />
				)}

				<div className="text-sm-right invoice-itbis-info">
					{Object.keys(sumatoriaFinal.impuestos).length > 1 && (
						<p
							style={{
								fontSize: "small",
							}}
						>
							{Object.keys(sumatoriaFinal.impuestos).includes(
								"Itbis 16%"
							) && (
								<>
									<span>
										Items con I1 son gravados con 16% ITBIS
									</span>
									<br />
								</>
							)}
							{Object.keys(sumatoriaFinal.impuestos).includes(
								"Itbis 18%"
							) && (
								<span>
									Items con I2 son gravados con 18% ITBIS
								</span>
							)}
						</p>
					)}
					{Object.keys(sumatoriaFinal.impuestos).length > 1 && (
						<div className="row justify-content-between justify-content-md-end">
							<div
								className="col col-md-6 pr-1"
								style={{
									maxWidth: "11rem",
									fontSize: "small",
									fontWeight: "600",
								}}
							>
								TOTAL IMPUESTOS
							</div>
							<div
								className="col-2"
								style={{
									maxWidth: "9rem",
									fontSize: "small",
									fontWeight: "600",
								}}
							>
								{/* {formatCurrency(factura.impuestos, "$")} */}
								{formatCurrency(impuestosTotal, "$")}
							</div>
						</div>
					)}
				</div>
			</div>

			<hr className="d-block d-sm-none mt-0" />
			{factura.notas && (
				<>
					<p className="font-weight-bold">Notas:</p>
					<p
						className="col-12 col-md-6 pl-0"
						style={{
							fontSize: "1rem",
							whiteSpace: "pre-line",
							lineHeight: "normal",
						}}
					>
						{factura.notas}
					</p>
				</>
			)}
			{factura.plantilla?.pie_pagina && (
				<div
					className="col-12 pt-5 text-center d-flex justify-content-center"
					style={{
						fontWeight: "600",
						fontSize: "1rem",
						whiteSpace: "pre-line",
						lineHeight: "normal",
					}}
				>
					<p className="text-center pie-pagina">
						{factura.plantilla?.pie_pagina}
					</p>
				</div>
			)}
		</div>
	</>);
};

export default PrintSingleCotizacion;
